import React from "react";
import { Flower2, CalendarClock, ShieldCheck, HandHeart } from "lucide-react";

const COVERAGE = [
  {
    Icon: Flower2,
    title: "Final Expense Insurance",
    range: "$5,000 – $25,000",
    desc: "Cover funeral, burial, and end-of-life costs so your family isn't financially burdened. Easy qualification for ages 50–85.",
    color: "bg-amber-50 text-amber-800 border-amber-200",
  },
  {
    Icon: CalendarClock,
    title: "Term Life Insurance",
    range: "10, 15, 20 & 30-Year Terms",
    desc: "Affordable coverage during the years you need it most. Many seniors lock in rates while still in good health.",
    color: "bg-blue-50 text-blue-900 border-blue-200",
  },
  {
    Icon: ShieldCheck,
    title: "Whole Life Insurance",
    range: "Lifetime Coverage",
    desc: "Permanent protection with rates that never increase and benefits that never decrease. Builds cash value over time.",
    color: "bg-emerald-50 text-emerald-800 border-emerald-200",
  },
  {
    Icon: HandHeart,
    title: "Guaranteed Issue",
    range: "No Questions Asked",
    desc: "Acceptance is guaranteed for ages 45–85 regardless of health history. No medical exam, no health questions.",
    color: "bg-rose-50 text-rose-800 border-rose-200",
  },
];

export const CoverageTypes = () => {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-green-700">
            Coverage Options
          </p>
          <h2
            data-testid="coverage-heading"
            className="font-serif-display mt-3 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-blue-900"
          >
            Find the plan that fits your budget — and your peace of mind.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {COVERAGE.map(({ Icon, title, range, desc, color }, idx) => (
            <article
              key={title}
              data-testid={`coverage-card-${idx}`}
              className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-5">
                <div
                  className={`h-14 w-14 rounded-xl border flex items-center justify-center ${color}`}
                >
                  <Icon className="h-7 w-7" />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-slate-900 leading-tight">
                    {title}
                  </h3>
                  <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-slate-500">
                    {range}
                  </p>
                </div>
              </div>
              <p className="mt-4 text-lg text-slate-700 leading-relaxed">
                {desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
